import imageService from '@/services/image-service'
import paronApi from '@/utils/paron-api'
import { emptyImage } from '@/components/ImageInput'

export default {
    data() {
        return {
            image: emptyImage()
        }
    },
    methods: {
        setExistingImage(existing) {
            const description = (existing && existing.description) || ''
            this.image = {
                ...emptyImage(),
                existing: existing && existing.id ? { ...existing, url: paronApi.imageUrl(existing) } : null,
                description,
                originalDescription: description
            }
        },
        // ownerKey is the form field the backend uses to attach the image: memberId, partnerId, teamId or articleId
        saveImage(ownerKey, ownerId, upload = imageService.uploadNewImage) {
            const { existing, file, remove, description, originalDescription } = this.image
            const formData = new FormData()
            formData.append(ownerKey, ownerId)
            if (description) {
                formData.append('description', description)
            }
            if (file) {
                formData.append('file', file)
                return upload(formData)
            }
            if (existing && remove) {
                return imageService.deleteImageById(existing.id)
            }
            if (existing && description !== originalDescription) {
                return imageService.editImageById(existing.id, formData)
            }
            return Promise.resolve()
        }
    }
}
